export const USER_TYPES = {
    BG_EMPLOYEE: 'BG Employee',
    AGENT: 'Agent',
    GROUP: 'Group',
  } as const;
  